/** constants */
import { ANODE, PRICE_ASSESSMENTS } from '~/constants/services/constants'

/** utils */
import {
  capacityDabaBaseSubTitle,
  capacityDabaBaseTitle,
} from '~/src/utils/capacity-database'
import { cloudinaryBuildRoute } from '~/src/utils/cloudinary'

/** types */
import type { TCDImages, TCDSeo } from '~/src/types/capacity-database'

export const CD_ANODE_CHECKBOXES = [ANODE.checkbox, PRICE_ASSESSMENTS.slug]

export const CD_ANODE_ICON = ANODE.iconColor
export const CD_ANODE_NAME = ANODE.name
export const CD_ANODE_SLUG = ANODE.slug

export const CD_ANODE_TITLE = capacityDabaBaseTitle(CD_ANODE_NAME)
export const CD_ANODE_SUBTITLE = capacityDabaBaseSubTitle(CD_ANODE_NAME)

export const CD_ANODE_SEO: TCDSeo = {
  title: `${PRICE_ASSESSMENTS.name}: ${CD_ANODE_NAME}`,
  description:
    'Headquartered: Download chart as image Anode Producers: Total Capacity Pipeline: tpa',
}

export const CD_ANODE_CIRCLE_COLOR_CLASS = [
  'bg-grey-900',
  'bg-white',
  'bg-white',
  'bg-grey-900',
]
export const CD_ANODE_CHECK_COLOR_CLASS = [
  'text-grey-900',
  'text-white',
  'text-white',
  'text-grey-900',
]
export const CD_ANODE_UNIT = 'tpa'
export const CD_ANODE_COLORS = ['#FDBD00', '#00325C', '#005BA9', '#2699FC']

export const CD_ANODE_UNAUTHORIZED_TITLE = {
  icon: CD_ANODE_ICON,
  text: CD_ANODE_TITLE,
}

export const CD_ANODE_UNAUTHORIZED_HERO = {
  title: CD_ANODE_TITLE,
  initialFields: CD_ANODE_CHECKBOXES,
  images: {
    desktop: cloudinaryBuildRoute(
      'v1719441567/assets/market/anode/prices/benchmarkminerals_Charts_and_graphs_about_Lithium_photorealisti_86b5c406-e222-4b36-8973-097c3adaa718_w6sth9.png',
      ['w_1920'],
      true,
      ['c_fill'],
    ),
    mobile: cloudinaryBuildRoute(
      'v1719441567/assets/market/anode/prices/benchmarkminerals_Charts_and_graphs_about_Lithium_photorealisti_86b5c406-e222-4b36-8973-097c3adaa718_w6sth9.png',
      ['w_1024'],
      true,
      ['c_fill'],
    ),
  },
  file: null,
}

export const CD_ANODE_UNAUTHORIZED_PACKAGES = {
  title: `${PRICE_ASSESSMENTS.singularName} Package`,
  services: [
    {
      icon: 'services/icon-chart-line',
      description:
        'Access to exclusive Anode data, with company and regional capacity, and supply demand/analytics',
    },
    {
      icon: 'services/icon-report',
      description:
        'Monthly report providing Anode prices and insights to reveal the direction of the midstream battery sector',
    },
    {
      icon: 'services/icon-presentation',
      description:
        'Produce custom made representations of data to download for projects and presentations.',
    },
    {
      icon: 'services/icon-consultancy',
      description:
        'Create your own custom pricing charts using our bespoke data.',
    },
    {
      icon: 'services/icon-global',
      description:
        'A global perspective on the evolution of the Anode industry.',
    },
    {
      icon: 'services/icon-idea',
      description:
        'Our goal is to help you understand the context of our data, not just give you the numbers.',
    },
  ],
  classes: '',
}
export const CD_ANODE_UNAUTHORIZED_SUBSCRIBE = {
  checkboxes: CD_ANODE_CHECKBOXES,
  methodology: null,
}

export const CD_ANODE_UNAUTHORIZED_IMAGES: TCDImages = {
  big: {
    src: cloudinaryBuildRoute(
      'v1718930173/assets/market/anode/capacities-database/anode-capacities-description-desktop_tq4vjm.png',
      ['w_420'],
      true,
      ['c_fill'],
    ),
  },
  small: {
    src: cloudinaryBuildRoute(
      'v1718930235/assets/market/anode/capacities-database/anode-capacities-description-desktop-2_r0hhnu.png',
      ['w_240'],
      true,
      ['c_fill'],
    ),
  },
}
